// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JARu","placeholdersHeader":"styles_placeholdersHeader__ssrCF","editorStyle":"styles_editorStyle__2yvNV","placeholdersBox":"styles_placeholdersBox__dTkmf"};